import { Timestamp } from '@/db/firestore';

import { CardModel } from '@/models/card';
import { Guid } from 'guid-typescript';

export class Cards {
    public empty(): CardModel {
        return {
            guid: Guid.create().toString(),
            question: "",
            answer: "",
            createdAt: Timestamp.now()
        }
    }
}